
import { Marker, Popup } from 'react-leaflet';
import useZoomLevel from './useZoomLevel'; 
import { SERVICE_HOUSE_URL } from '../OpticApiConfig';

const MarkersViewingAmplifier = ({ data, icon, layersVisibilityCommunications, isLineDrawing, showKtvLayer}) => {


    const zoomLevel = useZoomLevel();
    
    return (
      <>
      {data.map((item, index) => {

        if (zoomLevel <= 16) {
          return null;
        }
      
        const shouldDisplayMarker = layersVisibilityCommunications && showKtvLayer;

        if (!shouldDisplayMarker) {
          return null;
        }

        return (
          <Marker
            key={index}
            position={[item.latitude, item.longitude]}
            icon={icon}
          >
            {!isLineDrawing && (
                <Popup className="custom-popup">
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <img 
                      src="./amplifier.png" 
                      width="40" 
                      height="40" 
                      style={{ marginBottom: "5px" }} 
                      alt="House"
                    />
                  </div>
                  <span style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    <a href={`${SERVICE_HOUSE_URL}?HouseId=${item.hid}`} target="_blank" style={{ fontWeight: 'bold', color: "#444444" }}>
                      {item.street}, дом. {item.house}
                    </a>
                  </span>
                  <br />
                  
                  <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
                      Подъезд:
                      <span style={{ color: 'black', fontWeight: 'normal' }}> {item.entrance}</span>
                    </span>
                    <hr className='horizontalLineFilter' />
                    <span style={{ fontWeight: 'bold', fontSize: '14px' }}>Усилитель:</span> {item.model} <br />
              </Popup>
              )}
            </Marker>
        );
      })}
      </>
    );
  };
  
  export default MarkersViewingAmplifier;